import { GetVehicleModel } from "@factory/model/query-model-vehicle";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { vehicleFormDefault } from "./form.default";
import { VehicleFormSchema } from "./form.rule";

export const useFormDefaultVehicle = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetVehicleModel | undefined) => {
    return !cachedValue
      ? vehicleFormDefault
     : ({
        tenant: cachedValue.tenant,
        userCode: cachedValue.user_code,
        plateNumber: cachedValue.plate_number,
        make: cachedValue.make,
        model: cachedValue.model,
        year: cachedValue.year,
        color: cachedValue.color,
        nickname: cachedValue.nickname,
        remarks: cachedValue.remarks,
        avatar: cachedValue.avatar,
        isBlocked: Boolean(cachedValue.is_blocked),
      } as VehicleFormSchema);
  };

  return {
    getDefault,
  };
};
